import * as React from 'react';
import { Navigate } from 'react-router';

import RelapseForm from './Form';
import HistoryRowData from './HistoryRowData';

import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import HistoryRow from 'Components/HistoryRow';
import FormEditingHandler from 'Containers/FormEditingHandler';
import HistoryRowControls from 'Components/HistoryRowControls';
import { formatPartialDate } from 'Utility/date';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { path } from 'Utility/ramdaReplacement';
import { sortDocumentsDescending } from 'Utility/documentHandling';

const Relapse = ({ documents }: IOwnProps): React.JSX.Element => {
  const [redirect, setRedirect] = React.useState<boolean>(false);

  const toggleRedirect = (): void => {
    setRedirect(!redirect);
  };

  return (
    <FormEditingHandler name="relapse" documents={documents}>
      {(...args): React.JSX.Element => {
        const [editing, startEdit, formData, , saveDraft] = args;
        return (
          <React.Fragment>
            <DocumentWrapper>
              <DocumentHeader
                name={'relapse'}
                headerId={'relapse.title'}
                editing={editing}
                editButtons={
                  <div>
                    <DocumentCreationButton name="relapse" text={'general.new'} onClick={startEdit({})} />
                  </div>
                }
              />
              {!editing
                ? documents.toSorted(sortDocumentsDescending).map(r => (
                    <HistoryRow
                      headerText={'startDate' in r && r.startDate ? formatPartialDate(r.startDate) : undefined}
                      key={r._id}
                      rowButton={<HistoryRowControls document={r} startEdit={startEdit} />}
                      controlsMargin={false}
                    >
                      <HistoryRowData document={r} />
                    </HistoryRow>
                  ))
                : undefined}
              {editing ? (
                <RelapseForm
                  document={path([0], documents)}
                  editing={editing}
                  formData={formData}
                  saveDraft={saveDraft}
                  toggleRedirect={toggleRedirect}
                />
              ) : undefined}
            </DocumentWrapper>
            {redirect ? <Navigate to={{ pathname: '/medication' }} state={{ relocate: 'medication' }} /> : undefined}
          </React.Fragment>
        );
      }}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'relapse'>[];
}

export default Relapse;
